import React, { Component } from 'react'
import Card from '../Card'
import './ShareThisPost.scss'

class ShareThisPost extends Component {
  constructor(props) {
    super(props)
    this.handleScroll = this.handleScroll.bind(this)
    this.state = {
      show: false,
    }
  }
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll(event) {
    if (window.scrollY > this.props.headerOffSet) {
      this.setState({ show: true })
    } else {
      this.setState({ show: false })
    }
  }

  render() {
    return (
      <Card>
        <div
          className={this.state.show ? 'share-left-bar show' : 'share-left-bar'}
          data-addthis-url={this.props.shareUrl}
          data-addthis-title={this.props.shareTitle}
        >
          <a className="addthis_button_facebook facebook-button button">
            <i className="fa fa-facebook"></i>
          </a>
          <a className="addthis_button_twitter twitter-button button">
            <i className="fa fa-twitter"></i>
          </a>
          <a className="addthis_button_print print-button button">
            <i className="fa fa-print"></i>
          </a>
          <a className="addthis_button_more more-button button">
            <i className="fa fa-plus"></i>
          </a>
        </div>
        <script
          type="text/javascript"
          src="https://s7.addthis.com/js/250/addthis_widget.js#pubid=activelamp"
        ></script>
      </Card>
    )
  }
}

export default ShareThisPost
